<template>
  <v-container fill-height fluid grid-list-xl>
    <user-detail v-model="dialog" :user="item" @save="save_user" @clear="clear_user"></user-detail>
    <user-role v-model="dialog_role" :user="item"></user-role>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="primary" title="Lista de Usuários">
          <v-row>
            <v-col cols="4" >
              <v-text-field v-model="filtro" label="Pesquisa" placeholder="Filtro de pesquisa" append-icon="mdi-magnify" hide-details dense clearable outlined></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialog = true" :disabled="!hasRole([`ADMIN`, `user:create`])" style="margin-right: 1%" outlined>
              <v-icon left>mdi-account-plus</v-icon>NOVO USUÁRIO
            </v-btn>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="filtro"
            :key="index"
          >
            <template v-slot:item.enabled="{ item }">
                <v-switch v-model="item.enabled" :loading="item.loading" :readonly="!hasRole([`ADMIN`, `user:enable`])" color="success" inset :true-value="1" :false-value="0" @change="enable(item)"></v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-2" icon :disabled="item.loading || !hasRole([`ADMIN`, `client-detail:read`])" v-on="on" @click="edit_roles(item)">
                      <v-icon color="warning">mdi-apps</v-icon>
                  </v-btn>
                </template>
                <span style="color:#FFF">Perfis</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-2" icon :disabled="item.loading || !hasRole([`ADMIN`, `user:update`])" v-on="on" @click="edit(item)">
                      <v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span style="color:#FFF">Editar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card.vue'
import UserDetail from '@/views/user/Detail.vue'
import UserRole from '@/views/user/UserRole.vue'

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    dialog: null,
    dialog_role: null,
    loading: null,
    headers: [
      { sortable: true, text: '#', value: 'id', width: '30%' },
      { sortable: true, text: 'User Name', value: 'username' },
      { sortable: true, text: 'E-mail', value: 'email' },
      { sortable: false, text: 'Habilitado', value: 'enabled', align: 'center', width: '5%' },
      { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '15%' }
    ],
    item: {},
    index: 0
  }),
  mounted() {
    this.search()
  },
  components: {
      MaterialCard,
      UserDetail,
      UserRole
  },
  computed: {
    ...mapState('user', ['filter', 'users']),
    ...mapGetters('app', ['hasRole']),
    filtro: {
      get() { return this.filter },
      set(value) { this.SET_FILTER(value) }
    },
    items: {
      get() { return this.users },
      set(value) { this.SET_USERS(value) }
    }
  },
  methods: {
    ...mapMutations('user', ['SET_FILTER', 'SET_USERS']),
    ...mapActions('product', { init_product: 'init_select' }),
    ...mapActions('role', { init_role: 'init_select' }),
    async search() {
      this.loading = true
      try {
        await Promise.all([this.init_product(), this.init_role()])
        this.axios.get(this.$store.state.url_api + '/user')
        .then(r => {
          this.items = r.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
      }
      catch(_) {
        this.loading = false
      }
    },
    async enable(item) {
      item.loading = true
      try {
        await this.axios.put(this.$store.state.url_api + '/user/'+ item.id +'/enable/'+ item.enabled)
      }
      catch {
        item.enabled = item.enabled == 0 ? 1 : 0
      }
      item.loading = false
      this.index += 1
    },
    edit(item) {
      this.item = Object.assign({}, item)
      this.dialog = true
    },
    edit_roles(item) {
      this.item = Object.assign({}, item)
      this.dialog_role = true
    },
    save_user({ item, isNew }) {
      if (isNew) {
        this.items.push(item)
      }
      else {
        var index = 0
        this.items.forEach(function (c) { 
          if (c.id == item.id) return ;
          index++;
        })
        this.items[index] = Object.assign({}, item)
        this.index += 1;
      }
      this.dialog = false
      this.item = {}
    },
    clear_user() {
      this.item = {}
    }
  }
}
</script>
